var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactMe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 442",
    style: {
      enableBackground: "new 0 0 500 442"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F9001F;}\n\t.st1{opacity:0.1;enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:0.9;}\n\t.st4{opacity:0.1;fill:#263238;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M437.7,162.1l16.9,196.2c1.3,15.9-8.4,30-21.7,31.1l-372.3,32c-13.3,1.1-25.3-11-26.6-27L17.1,198.2 c-0.3-3.7,0-7.4,0.9-11c2.7-10.9,10.7-19.4,20.8-20.1l372.3-32c10.1-0.9,19.4,5.9,24,16.3C436.5,154.8,437.5,158.4,437.7,162.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.7,162.1l16.9,196.2c1.3,15.9-8.4,30-21.7,31.1l-372.3,32c-13.3,1.1-25.3-11-26.6-27L17.1,198.2 c-0.3-3.7,0-7.4,0.9-11c2.7-10.9,10.7-19.4,20.8-20.1l372.3-32c10.1-0.9,19.4,5.9,24,16.3C436.5,154.8,437.5,158.4,437.7,162.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.9,
    y: 277.9,
    transform: "matrix(0.9928 -0.12 0.12 0.9928 -30.3993 59.784)",
    className: "st0",
    width: 2.7,
    height: 8.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.2,
    y: 235,
    transform: "matrix(0.9928 -0.12 0.12 0.9928 -26.7475 59.1206)",
    className: "st0",
    width: 2.7,
    height: 33.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.4,127.1l24.3,201.2c2,16.4-7.6,31.1-21.2,32.8L75.8,407.2c-13.6,1.7-26.4-10.4-28.4-26.8L23.1,179.2 c-0.4-3.8-0.3-7.6,0.4-11.4c2.5-11.4,10.4-20.2,20.7-21.4L426,100.3c10.4-1.2,20.3,5.4,25.3,15.8 C452.9,119.5,454,123.3,454.4,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M451.3,116.1L278.1,232.7c-17.2,11.7-39,14.4-58.5,7.1l-196-72c2.5-11.4,10.4-20.2,20.7-21.4l381.8-46.3 C436.4,99,446.3,105.7,451.3,116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M386.7,159.6L337,193l-16.3,11l-42.6,28.6c-16.7,11.5-38,14.3-57.1,7.6l-1.6-0.6l-23.9-8.8l-53.7-19.6 l-25.1-9.3l-28.4-10.5l-2-50.3L81.7,29.5l218.6-8.9l83.3,63.1l0.9,21.5L386.7,159.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.9,106L114,115.8c-2.8,0.1-5.2-2-5.4-4.8l0,0c-0.1-2.8,2-5.1,4.8-5.4l241.9-9.8c2.8-0.1,5.2,2,5.4,4.8 l0,0C360.8,103.5,358.7,105.9,355.9,106z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.1,138.2L115.3,148c-2.8,0.1-5.2-2-5.4-4.8l0,0c-0.1-2.8,2-5.1,4.8-5.4l241.9-9.8c2.8-0.1,5.1,2,5.4,4.8 l0,0C362,135.6,359.9,138,357.1,138.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.5,170.3l-241.9,9.8c-2.8,0.1-5.2-2-5.4-4.8l0,0c-0.1-2.8,2-5.1,4.8-5.4l241.9-9.8c2.8-0.1,5.1,2,5.4,4.8 l0,0C363.4,167.7,361.3,170.1,358.5,170.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337,193l-16.3,11l-178.8,7.2l-25.1-9.3c0.2,0,0.4,0,0.7,0L337,193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.7,233.1v0.2c0,2.8-2.1,5-4.8,5.1l-44.8,1.8l-1.6-0.6l-23.9-8.8l69.8-2.9 C268.3,228.2,270.6,230.3,270.7,233.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "383.5,83.8 325.7,81.4 300.3,20.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "383.5,83.8 327.5,74.2 300.3,20.7  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMe);
export default __webpack_public_path__ + "static/media/contactMe.0ca9c67eb93283bca2d2db6fcd154ded.svg";
export { ForwardRef as ReactComponent };